import React from "react";

import { PricingPlanCard } from "./PricingPlanCard";

export const PricingPlansSection: React.FC = () => {
  return (
    <div>
      <div className="hidden lg:block ">
      <section className="w-full flex justify-center my-14 relative z-20 bg-[#F3F3F3]">
      <div className="w-full max-w-[1700px] px-6">
        <div className="relative z-10 flex flex-col items-center justify-center px-6">
        <div className="flex items-center justify-center gap-3 text-[#2A2A2A]">
              <span className="w-[14px] h-[14px] rounded-full bg-[#D90000]" />
              <span className="text-[16px] font-medium">Premium Plan</span>
            </div>
        <h2 className="mt-6 text-gray-600 text-[40px] mb-12 leading-[1.05] font-medium tracking-[-1.2px] text-center">
                  Plans That Grow With Your Business
                </h2>

                
                </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          
          <PricingPlanCard
            title="Starter"
            price="Free"
            features={[
              "Up to 3 active coupons",
              "Basic analytics dashboard",
              "Email support",
              "Standard redemption processing",
            ]}
            feeText="Access to valuable business add-ons"
            buttonText="Start for Free"
          />

          <PricingPlanCard
            title="Growth"
            price="$65"
            period="month"
            featured
            badgeText="Most Popular"
            features={[
              "20 active coupons",
              "Build for unlimited growth",
              "AI-Powered image generation",
              "Priority support & onboarding",
              "Advanced analysts & insights",
            ]}
            feeText="Get up to 20% points back on add-on purchases"
            buttonText="Start Free Trial"
          />
        </div>
      </div>
    </section>
      </div>


      <div className="block lg:hidden">
      <section className="w-full flex justify-center py-14 relative z-20 bg-[#F3F3F3]">
      <div className="w-full max-w-[1700px] px-6">
        <div className="relative z-10 flex flex-col items-center justify-center px-6">
        <div className="flex items-center justify-center gap-3 text-[#2A2A2A]">
              <span className="w-[14px] h-[14px] rounded-full bg-[#D90000]" />
              <span className="text-[16px] font-medium">Premium Plan</span>
            </div>
        <h2 className="mt-6 mb-12 text-gray-600 text-[30px] leading-[1.05] font-medium tracking-[-1.2px] text-center">
                  Plans That Grow With Your Business
                </h2>

                
                </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          
          <PricingPlanCard
            title="Starter"
            price="Free"
            features={[
              "Up to 3 active coupons",
              "Basic analytics dashboard",
              "Email support",
              "Standard redemption processing",
            ]}
            feeText="Access to valuable business add-ons"
            buttonText="Start for Free"
          />

          <PricingPlanCard
            title="Growth"
            price="$65"
            period="month"
            featured
            badgeText="Most Popular"
            features={[
              "20 active coupons",
              "Build for unlimited growth",
              "AI-Powered image generation",
              "Priority support & onboarding",
              "Advanced analysts & insights",
            ]}
            feeText="Get up to 20% points back on add-on purchases"
            buttonText="Start Free Trial"
          />
        </div>
      </div>
    </section>
      </div>
    </div>
    
  );
};